import { VisitsPageV2 } from "../../../ui/pages/v2";

export function VisitsV2Route() {
  return <VisitsPageV2 />;
}
